import { createSlice } from '@reduxjs/toolkit';

const loadFromLocalStorage = (key, defaultValue) => {
	try {
		const raw = localStorage.getItem(key);
		const { version, ...parsed } = raw ? JSON.parse(raw) : {};
		if (version !== process.env.REACT_APP_FILTERS_VERSION) {
			return defaultValue;
		}
		return { ...defaultValue, ...parsed };
	} catch (err) {
		localStorage.removeItem(key);
		return defaultValue;
	}
};

const saveToLocalStorage = (key, value) => {
	localStorage.setItem(
		key,
		JSON.stringify({ ...value, version: process.env.REACT_APP_FILTERS_VERSION }),
	);
};

export const createFilterSlice = ({ sliceName, storageKey, defaultFilters }) => {
	const initialState = loadFromLocalStorage(storageKey, defaultFilters);

	const reducers = {};
	Object.keys(defaultFilters).forEach((key) => {
		const actionName = `set${key[0].toUpperCase() + key.slice(1)}`;
		reducers[actionName] = (state, action) => {
			state[key] = action.payload;
			saveToLocalStorage(storageKey, state);
		};
	});

	reducers.resetFilters = (state) => {
		Object.keys(defaultFilters).forEach((key) => {
			state[key] = defaultFilters[key];
		});
		saveToLocalStorage(storageKey, state);
	};

	// Payload is { [key]: validValues[] }. Arrays keep only valid values; a single invalid
	// value goes back to its default.
	reducers.pruneFilters = (state, action) => {
		let changed = false;
		Object.entries(action.payload).forEach(([key, validValues]) => {
			const value = state[key];
			if (Array.isArray(value)) {
				const validValue = value.filter((v) => validValues.includes(v));
				if (validValue.length !== value.length) {
					state[key] = validValue;
					changed = true;
				}
			} else if (value != null && !validValues.includes(value)) {
				state[key] = defaultFilters[key];
				changed = true;
			}
		});
		if (changed) saveToLocalStorage(storageKey, state);
	};

	return createSlice({
		name: sliceName,
		initialState,
		reducers,
	});
};
